"use client";

import { useAuthStore } from "@/app/hooks/auth";
import useLoginModal from "@/app/hooks/useLoginModal";
import { useServiceReviewModal } from "@/app/hooks/useServiceReviewModal";
import { useState } from "react";

interface LeaveReviewButtonProps {
  label?: string;
  className?: string;
}

export default function LeaveReviewButton({
  label = "Deixar avaliação",
  className,
}: LeaveReviewButtonProps) {
  const login = useLoginModal();
  const reviewModal = useServiceReviewModal();

  const user = useAuthStore((s) => s.user);
  const userId = user?.id;

  const [loading, setLoading] = useState(false);

  function handleClick() {
    if (loading) return;

    if (!userId) {
      console.log("🟡 Usuário não logado → abrindo LoginModal");
      login.open();
      return;
    }

    // 🔥 usuário logado → OK
    reviewModal.open();
  }

  return (
    <button
      disabled={loading}
      onClick={handleClick}
      className={
        className ??
        "rounded-full px-6 py-3 bg-brand-600 text-white hover:bg-brand-500 transition shadow"
      }
    >
      {label}
    </button>
  );
}
